/* permet de rechercher un terme dans le début de chaque mot d'une phrase Ex : "Airbus CAPEX"  et "canal du midi" répondront à la recherche "ca" par exemple   */
export function trouveMotDebutantParSearchDansPhrase(search, phrase) {
  let rechercheGlobale = phrase.nom + " " + phrase.descriptionReelle;
  let trouve = false;
  let decoupage = rechercheGlobale.toLowerCase().replace(/\n/g, " ").split(" ");
  decoupage.forEach((element) => {
    if (element.startsWith(search.toLowerCase())) {
      trouve = true;
    }
  });
  return trouve;
}
